(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["navigation"] && !Shopify.designMode) return;
  try {
    // <navigation-menu> custom HTML Element
  class NavigationMenu extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
    }
    disconnectedCallback() {
    }
  }
  customElements.define('navigation-menu', NavigationMenu);

  // <drop-down> custom HTML Element
  class DropDown extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
    }
    disconnectedCallback() {
    }
  }
  customElements.define('drop-down', DropDown);
  
  // <mega-menu> custom HTML Element
  class MegaMenu extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
    }
    disconnectedCallback() {
    }
  }
  customElements.define('mega-menu', MegaMenu);
  } catch(e) { console.error(e); }
})();

})();
